<script>
    export let expand = false;
</script>

<div class="display-small">
    <slot name="headerBar"></slot>
</div>
<div
        class="segment-container"
        class:container-margin={!expand}
        class:expand-container={expand}
>
    <div class="wrapper">
        <div class="first-segment">
            <div style="width: 100%;">
                <div class="display-big">
                    <slot name="headerBar"></slot>
                </div>
                <slot name="firstSegment"/>
            </div>
            <div class="divider-v divider"/>
        </div>
        <div/>
    </div>
    <div class="second-segment" class:expand>
        <slot name="secondSegment"/>
    </div>
</div>

<style>
    .segment-container {
        display: flex;
        justify-content: start;
        flex-direction: column;
    }

    .container-margin {
        margin-top: 16px;
        margin-bottom: 16px;
    }

    .divider {
        display: none;
    }

    .expand {
        height: 100%;
        padding-top: 0;
    }

    .expand-container {
        height: calc(100% - 76px);
        padding-top: 0;
    }

    @media only screen and (min-width: 1440px) {
        .segment-container {
            display: flex;
            justify-content: start;
            flex-direction: row;
            height: 100vh;
            margin-top: 0px;
        }

        .first-segment {
            margin: 48px 0 48px 24px;
            max-width: 620px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            height: 100%;
        }

        .second-segment {
            display: block;
            margin: 0px;
            padding-top: 48px;
            overflow: auto;
            overflow-x: hidden;
            flex-basis: 66.3%;
        }

        .divider {
            display: flex;
        }

        .wrapper {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex-basis: 33.7%;
        }

        .expand {
            height: 100%;
            padding-top: 0;
        }

        .display-small {
            display: none;
        }
    }
</style>
